import { IceRowType, DATETYPE } from "../helpers/constant";
import {
  IceDurationType,
  DurationType,
  RepaymentTypeOptionValue,
} from "../helpers/constant";
import { ProjectionCalculationService } from "../services";

export default {
  data() {
    return {
      ProjectionDate: "01/07/2025",
    };
  },

  methods: {
    fillBasicProjectionInfo(formModel, projectionBasicField) {
      let projectionInfo = [];

      for (let element in IceRowType) {
        let row = {};
        if (!projectionBasicField[element]) {
          continue;
        }
        for (let i = 0; i < projectionBasicField[element].length; i++) {
          row[projectionBasicField[element][i]["map"]] =
            formModel[projectionBasicField[element][i]["key"]];
        }
        row.Type = IceRowType[element];
        if (row.Type == IceRowType.Investment_Maturity_Date) {
          if (formModel.isRenewAuto) row.Amount = 0;
          else row.Amount = 1;
        }

        row.StartType =
          row.Type == IceRowType.Investment_Maturity_Date
            ? formModel.maturityDate
              ? DATETYPE.Other
              : DATETYPE.Max
            : DATETYPE.Start;
        row.Start =
          IceRowType.Investment_Maturity_Date && formModel.maturityDate
            ? "01/" + formModel.maturityDate
            : "";
        row.EndType =
          row.Type == IceRowType.OpeningBalance ||
          row.Type == IceRowType.LoanTerm ||
          row.Type == IceRowType.Investment_Balance
            ? 0
            : DATETYPE.Max;
        row.Frequency = isNaN(row.Frequency) ? 0 : parseInt(row.Frequency);
        row.END = "";
        row.AccountNumber = "";
        row.EffectiveAsOn =
          row.Type == IceRowType.Investment_In_Reg ||
          row.Type == IceRowType.LoanRepayment
            ? 2
            : 0;
        row.Description = formModel.description;
        row.Indexation = 0;
        row.IsBaseLineField = true;
        if (this.ValidateAmount(row.Type, "Amount", row.Amount)) {
          if (row.Type == IceRowType.LoanStructure) {
            row.Datapoint_PeriodEndDateYear = row.Amount;
            row.Amount = 1;
            row.EndType = 0;
          } else {
            row.Datapoint_PeriodEndDateYear = 0;
          }
          projectionInfo.push(row);
        }
      }
      return projectionInfo;
    },
    prepareBaseAPIModel() {
      let inputClientData = {};
      inputClientData.ProjectionDuration = this.projectionYear.Value;
      inputClientData.ProjectionDate = this.ProjectionDate;
      inputClientData.ClientInfo = this.fillClientInfo();
      inputClientData.PartnerInfo = this.fillPartnerInfo();
      return inputClientData;
    },
    async getProjection(inputData, fileName) {
      const iceApiResponse =
        await ProjectionCalculationService.getIceProjectionInformation(
          inputData,
          fileName
        );
      if (iceApiResponse && iceApiResponse.status == 200) {
        console.log(iceApiResponse.data.iceInput);

        return iceApiResponse.data;
      } else {
        return {};
      }
    },

    ValidateAmount(rowId, key, value) {
      if (rowId == IceRowType.LoanTerm && key == "Amount" && value <= 0) {
        return false;
      }
      if (
        rowId == IceRowType.LoanStructure &&
        key == "Amount" &&
        !(
          value == RepaymentTypeOptionValue.first_Repayment_Year ||
          value == RepaymentTypeOptionValue.second_Repayment_Year ||
          value == RepaymentTypeOptionValue.third_Repayment_Year ||
          value == RepaymentTypeOptionValue.fourth_Repayment_Year ||
          value == RepaymentTypeOptionValue.fifth_Repayment_Year
        )
      ) {
        return false;
      }
      return true;
    },
    fillClientInfo() {
      let ClientInfo = {};
      if (this.ClientsInfo) {
        let clientData = this.ClientsInfo.filter((sr) => sr.entityType == 1);
        if (clientData && clientData.length > 0) {
          ClientInfo.Name = clientData[0].text;
          ClientInfo.DOB = clientData[0].dob;
          ClientInfo.Id = clientData[0].clientId;
          ClientInfo.RetirementAge = 65;
          ClientInfo.Sex = clientData[0].gender;
        }
      }
      return ClientInfo;
    },
    fillPartnerInfo() {
      let ClientInfo = {};
      if (this.ClientsInfo) {
        let clientData = this.ClientsInfo.filter((sr) => sr.entityType == 2);
        if (clientData && clientData.length > 0) {
          ClientInfo.Name = clientData[0].text;
          ClientInfo.DOB = clientData[0].dob;
          ClientInfo.Id = clientData[0].clientId;
          ClientInfo.RetirementAge = 65;
          ClientInfo.Sex = clientData[0].gender;
        }
      }
      return ClientInfo;
    },

    getICERepaymentFrequencyType(frequencyType) {
      if (frequencyType == DurationType.Weeks) {
        return IceDurationType.Weeks;
      } else if (frequencyType == DurationType.Years) {
        return IceDurationType.Years;
      } else if (frequencyType == DurationType.Months) {
        return IceDurationType.Months;
      } else if (frequencyType == DurationType.Fortnights) {
        return IceDurationType.Fortnights;
      } else if (frequencyType == DurationType.Half_Year) {
        return IceDurationType.Half_Year;
      } else {
        return "";
      }
    },
  },
};
